import { gql } from 'core/dna/types/apollo';

import { ORGANIZATION_DATA_FRAGMENT } from 'modules/planner/memory/apollo/_fragments';

export const GET_ORGANIZATIONS_QUERY = gql`
  query GetOrganizations {
    Organization {
      ...OrganizationData
      federation {
        id
        name
      }
      terms {
        id
        name
        startDate {
          formatted
        }
        endDate {
          formatted
        }
        holidays {
          formatted
        }
        allocationPlan {
          allocations {
            weekNumber
            published
          }
        }
      }
      features {
        code
        expired
        expiresAt {
          formatted
        }
      }
    }
  }
  ${ORGANIZATION_DATA_FRAGMENT}
`;
